import { render, staticRenderFns } from "./CompletedTA6.vue?vue&type=template&id=548a985e&scoped=true&"
import script from "./CompletedTA6.vue?vue&type=script&lang=js&"
export * from "./CompletedTA6.vue?vue&type=script&lang=js&"
import style0 from "./CompletedTA6.vue?vue&type=style&index=0&id=548a985e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548a985e",
  null
  
)

export default component.exports